const salaryOptions = [
    { value: "Below 3 Lakhs per year", label: "Below 3 Lakhs per year" },
    { value: "3 to 5 Lakhs per year", label: "3 to 5 Lakhs per year" },
    { value: "5 to 7 Lakhs per year", label: "5 to 7 Lakhs per year" },
    { value: "7 to 9 Lakhs per year", label: "7 to 9 Lakhs per year" },
    { value: "9 to 12 Lakhs per year", label: "9 to 12 Lakhs per year" },
    { value: "12 to 15 Lakhs per year", label: "12 to 15 Lakhs per year" },
    { value: "15 to 18 Lakhs per year", label: "15 to 18 Lakhs per year" },
    { value: "18 to 22 Lakhs per year", label: "18 to 22 Lakhs per year" },
    { value: "22 to 26 Lakhs per year", label: "22 to 26 Lakhs per year" },
    { value: "26 to 30 Lakhs per year", label: "26 to 30 Lakhs per year" },
    { value: "30 to 35 Lakhs per year", label: "30 to 35 Lakhs per year" },
    { value: "35 to 40 Lakhs per year", label: "35 to 40 Lakhs per year" },
    { value: "40 to 45 Lakhs per year", label: "40 to 45 Lakhs per year" },
    { value: "45 to 50 Lakhs per year", label: "45 to 50 Lakhs per year" },
    { value: "50 to 60 Lakhs per year", label: "50 to 60 Lakhs per year" },
    { value: "60 to 70 Lakhs per year", label: "60 to 70 Lakhs per year" },
    { value: "70 to 80 Lakhs per year", label: "70 to 80 Lakhs per year" },
    { value: "80 Lakhs to 1 Cr per year", label: "80 Lakhs to 1 Cr per year" },
    { value: "Above 1 Cr per year", label: "Above 1 Cr per year" },
  ];

  export default salaryOptions